import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'language_code': 'String!',
}

export default gql(`
	mutation employee( ${ HelperGraphql.createFields( fields ) } ) {
	    employee( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	    }
	}
`);

